const KNOCK_WORKFLOWS = {
  EVENT_OPEN_REGISTER_24: 'registrations-open-in-24-hours',
  EVENT_OPEN_REGISTER_1: 'registrations-open-in-1-hour',
  EVENT_OPEN_REGISTER_NOW: 'registrations-now-open',
  EVENT_CLOSE_REGISTER_24: 'registrations-close-in-24-hours',
  EVENT_CLOSE_REGISTER_1: 'registrations-close-in-1-hour',
  EVENT_CANCEL: 'event-cancelled',
  RESULTS_PUBLISHED: 'results-published',
  RESULTS_UPDATED: 'results-updated',
  COGGINGS_EXPIRES_1: 'coggins-expires-1-month',
  COGGINGS_EXPIRES_24: 'coggins-expires-in-24-hours',
  MEASUREMENT_1_WEEK: 'measurements-card-expires-in-1-week',
  MEASUREMENT_24_HOURS: 'measurement-card-expires-in-24-hours',
  HORSE_MICROCHIP: 'horse-microchip-number-expires-in-1-month',
  HORSE_PASSPORT: 'horse-passport-number-expires-in-1-month',
  RIDE_TIME_PUBLISHED: 'ride-time-published',
  RIDE_TIME_UPDATED: 'ride-time-updated',
  REFUND_APPROVED: 'refund-approved',
  NEW_MESSAGE: 'new-message',
  PAPERWORK_TO_SIGN: 'paperwork-to-sign',
  DOCUMENT_NOT_SIGNED: 'document-not-signed',
  CONFIRM_REGISTRATION: 'confirm-registration',
  ORGANIZER_PUBLISHES_NEW_EVENT: 'organizer-publishes-new-event',
  RIDER_SCRATCHES: 'scratch-successful',
  RIDER_SCRATCHES_FEE: 'scratch-successful',
  RIDER_SCRATCHES_CLASS: 'scratch-successful-class',
  RIDER_REGISTATION: 'new-event-registration',
  SPECTATOR_TICKET_SOLD: 'spectator-ticket-sold',
  EVENT_WAITLIST: 'new-wait-list-registration',
  ADD_NEW_CLASS: 'add-new-class',
  ADD_NEW_FEES: 'add-new-fees',
  PRIZE_UPDATED: 'prize-updated',
  PRIZE_PUBLISHED: 'prize-published',
  REGISTRATION_SCRATCHED: 'registration-scratched',
  EVENT_PUBLISHED: 'event-published',
  DOCUMENT_SIGNED: 'document-signed',
  SEND_REQUEST_PAYMENT: 'send-request-payment',
  ACCOUNT_CREATED_FOR_YOU: 'account-created-for-you',
}

export { KNOCK_WORKFLOWS }
